import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import GeofenceIcon from '../../../../../layout/icons/GeofenceIcon';
import StyledToolTip from '../../../../common/StyledToolTip';

const styles = (theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  popupContainer: {
    minWidth: '120px'
  },
  value: {
    fontSize: theme.textFontSize,
    fontWeight: 600
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0'
  },
  title: {
    color: theme.iconColor,
    letterSpacing: 0.4,
    marginRight: 2
  }
});

const GeofenceDetail = ({ classes, enterTime, exitTime }) => {
  return (
    <div className={classes.popupContainer}>
      <div className={classes.details}>
        <div className={classes.title}>Geofence Entry </div>
        <span className={classes.value}>{enterTime}</span>
      </div>
      <div className={classes.details}>
        <div className={classes.title}>Geofence Exit </div>
        <span className={classes.value}>{exitTime ?? null }</span>
      </div>
    </div>
  );
};

const GeofenceToolTip = (props) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <StyledToolTip title={<GeofenceDetail {...props} />}>
        <div>
          <GeofenceIcon size={14} />
        </div>
      </StyledToolTip>
    </div>
  );
};

export default withStyles(styles)(GeofenceToolTip);
